import React, {useEffect} from "react";
import {OrderDraftColumn, ProductList, ProductsAndOrderItemsHeader} from "../components";
import {useCore} from "../hooks";
import {useNavigate} from "react-router";
import {toast} from "react-toastify";

export const ProductsAndOrderItems: React.FC = () => {
  const { selectedCheckoutId, checkouts, setSelectedCheckoutId } = useCore()
  const navigate = useNavigate()

  useEffect(() => {
    if (!selectedCheckoutId) {
      navigate('/checkout-select')
      return
    }
    // checkout could have been closed on another device, don't allow selling on closed checkout
    const checkout = checkouts?.find(c => c.id === selectedCheckoutId)
    if (!checkout) return
    const isOpen = checkout.currentClosing?.dateOpen && !checkout.currentClosing?.dateClosed
    if (!isOpen) {
      toast.warn(`Pokladna ${checkout.name} je uzavřená, nejprve ji otevřete`, { toastId: `checkout-closed-${checkout.id}` })
      setSelectedCheckoutId(undefined)
      navigate(`/checkout-open/${checkout.id}`)
    }
  }, [selectedCheckoutId, checkouts])

  return (
    <div className="w-full">
      <ProductsAndOrderItemsHeader />
      <div className="flex flex-row">
        <ProductList />
        <OrderDraftColumn />
      </div>
    </div>
  );
}
